import { InfoCircleFilled } from "@ant-design/icons"
import { Tooltip } from "components/Tooltip/Tooltip"
import { PatientDetailItem } from "interface/patientType"
import { ComponentProps } from "react"
import { cn } from "styles/cn"
import { kgToLbs } from "utils"

export function WeightLabel({
	fullName,
	dataPoint,
	className,
	...props
}: {
	fullName?: string
	dataPoint: PatientDetailItem
} & ComponentProps<"div">) {
	return (
		<p {...props} className={cn("flex gap-2 text-lg", className)}>
			{`${dataPoint.weightIsUnstable ? "~" : ""}${kgToLbs(dataPoint.weightInKilogramsForce)}`}
			{dataPoint.weightIsUnstable && (
				<Tooltip
					title={`${fullName ? `${fullName} was` : "You were"} moving too much during this screening to determine an accurate weight, so this is only a rough estimate`}
				>
					<InfoCircleFilled
						className="text-navy-60"
						aria-label="Unstable weight reading"
					/>
				</Tooltip>
			)}
		</p>
	)
}
